<ng-container *ngTemplateOutlet="pdfPage ? pdfParts : pdfPartChild ? pdfPartChildBlock : blocks"></ng-container>

<ng-template #pdfParts>
  <app-block *ngFor="let pdfPart of children; last as last" [id]="'block-' + pdfPart.id + (!!blocksConfig.idSuffix ? '-' + blocksConfig.idSuffix : '')"
             [block]="pdfPart"
             [ngClass]="{ 'last': last }"
             class="align-self-center"
             blockOwnerColorization
             blockSelection>

  </app-block>
</ng-template>

<ng-template #pdfPartChildBlock>
  <ng-container *ngTemplateOutlet="blockTemplate; context: { $implicit: block, last: false, pdfPartChild: true }"></ng-container>
  <div resizableHandle class="resize-handle" [ngClass]="'resize-' + block.settings.resizeAxis"></div>
</ng-template>

<ng-template #blocks>
  <app-drop-zone *ngFor="let b of children; last as last; trackBy: trackByFn"
                 class="child-wrap"
                 [block]="b"
                 [parent]="block"
                 [ngClass]="b.class+'-wrap'"
                 [disabled]="!blocksConfig.editable"
                 [class.full-width]="$any(b.styles).full_width">

    <ng-container *ngTemplateOutlet="blockTemplate; context: { $implicit: b, last: last }"></ng-container>
  </app-drop-zone>

  <app-drop-zone *ngIf="draggableService"
                 class="content"
                 [parent]="block"
                 [children]="children"
                 [disabled]="!blocksConfig.editable"
                 [class.group]="block.type === BlockType.Group">

    <div *ngIf="editorService?.bucketStore?.editable && !children.length"
         [id]="block.type === BlockType.Group ? domId + block.slug : null"
         class="empty-content"
         [style.top.px]=" $any(block.styles).padding ? -$any(block.styles).padding?.top : null "
         [style.right.px]=" $any(block.styles).padding ? -$any(block.styles).padding?.right : null "
         [style.bottom.px]=" $any(block.styles).padding ? -$any(block.styles).padding?.bottom : null "
         [style.left.px]=" $any(block.styles).padding ? -$any(block.styles).padding?.left : null ">

      <fa-icon [icon]="['fal', 'plus-circle']" size="lg"></fa-icon>
      <p class="header mb-0">{{ 'blocks.'+block.type+'.empty.title' | transloco }}</p>
      <p class="subheader mt-1 mb-0">{{ 'blocks.'+block.type+'.empty.subtitle' | transloco }}</p>
    </div>

  </app-drop-zone>
</ng-template>

<ng-template #blockTemplate let-b let-last="last" let-pdfPartChild="pdfPartChild">
  <app-draggable *visibleBlock="b"
                 [block]="b"
                 [disabled]="!blocksConfig.editable"
                 [class.selected-block-wrap]="blocksConfig.selectable && editorRouter && b.id === editorRouter.selectedBlock"
                 [class.pdf-part-child]="pdfPartChild">

    <div class="left"
         *ngIf="!pdfPartChild && blocksConfig.editable"
         [class.d-none]="!editorService?.bucketStore?.editable">
      <button appDragHandle
              type="button">
        <img src="/assets/images/drag-handle.svg">
      </button>
    </div>

    <app-block [id]="'block-' + b.id + (!!blocksConfig.idSuffix ? '-' + blocksConfig.idSuffix : '') "
               [block]="b"
               [ngClass]="b.class"
               [class.last]="last"
               [class.pdf-part-child]="pdfPartChild"
               appDragHandle
               [appDragHandleDisabled]="!pdfPartChild"
               absoluteDragHandle
               blockOwnerColorization
               blockSelection></app-block>

    <div *ngIf="blocksConfig.editable && editorService?.bucketStore?.editable"
         class="right">
      <button type="button"
              (click)="editorService.delete(b)"
              class="delete">
        <fa-icon [fixedWidth]="true" [icon]="['fas', 'trash']"></fa-icon>
      </button>
      <button type="button"
              (click)="editorService.duplicate(b)"
              class="clone">
        <fa-icon [fixedWidth]="true" [icon]="['fas', 'clone']"></fa-icon>
      </button>
    </div>
  </app-draggable>
</ng-template>
